import {shareEntityButtonStyles} from "@insite/content-library/Components/ShareEntityButton"
import { css } from "styled-components"

shareEntityButtonStyles.sendButton = {
    mergeCss: true,
    css: css`
        margin-left: 10px;
    `,
}